import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icp" }
const _hoisted_2 = ["title", "aria-expanded"]
const _hoisted_3 = {
  key: 0,
  class: "icp-badge"
}
const _hoisted_4 = {
  key: 0,
  class: "icp-example",
  role: "note"
}
const _hoisted_5 = {
  key: 1,
  class: "icp-note icp-example-note"
}
const _hoisted_6 = { class: "icp-body" }
const _hoisted_7 = {
  key: 0,
  class: "icp-note"
}
const _hoisted_8 = {
  key: 1,
  class: "icp-note"
}
const _hoisted_9 = ["onClick", "onMouseenter"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "icp-main" }
const _hoisted_12 = { class: "icp-line" }
const _hoisted_13 = {
  key: 0,
  class: "icp-count"
}
const _hoisted_14 = { class: "icp-sec icp-sec--agents" }
const _hoisted_15 = { class: "icp-sec-count" }
const _hoisted_16 = {
  key: 2,
  class: "icp-note"
}
const _hoisted_17 = ["onClick", "onMouseenter"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "icp-main" }
const _hoisted_20 = { class: "icp-line" }
const _hoisted_21 = { class: "icp-prev" }
const _hoisted_22 = {
  key: 0,
  class: "icp-count"
}
const _hoisted_23 = {
  key: 0,
  class: "icp-note"
}
const _hoisted_24 = ["onClick", "onMouseenter"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "icp-main" }
const _hoisted_27 = { class: "icp-line" }
const _hoisted_28 = { class: "icp-prev" }
const _hoisted_29 = {
  key: 0,
  class: "icp-count"
}
const _hoisted_30 = {
  key: 0,
  class: "icp-note"
}
const _hoisted_31 = {
  key: 1,
  class: "icp-note"
}
const _hoisted_32 = {
  key: 2,
  class: "icp-note icp-warn"
}
const _hoisted_33 = {
  key: 3,
  class: "icp-note"
}
const _hoisted_34 = ["title"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "icp-main" }
const _hoisted_37 = { class: "icp-line" }
const _hoisted_38 = { class: "icp-prev" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 1,
  class: "icp-tag"
}
const _hoisted_41 = { class: "icp-card-head" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "icp-card-id" }
const _hoisted_44 = { class: "icp-card-body" }
const _hoisted_45 = {
  key: 0,
  class: "icp-card-row"
}
const _hoisted_46 = { class: "icp-card-text" }
const _hoisted_47 = { class: "icp-card-row" }
const _hoisted_48 = {
  key: 1,
  class: "icp-card-row"
}
const _hoisted_49 = {
  key: 2,
  class: "icp-card-row icp-card-atend"
}
const _hoisted_50 = {
  key: 3,
  class: "icp-card-row icp-card-unread"
}

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { usePermission } from '@/composables/usePermission'
import { useAgentChatCp, type ChatAgentCp } from '@/composables/useAgentChatCp'
import { useWootDashLiveData } from '@/composables/useWootDashLiveData'
import { useChatRailMode } from '@/composables/useChatRailMode'
import { onInternalMessage } from '@/composables/useConversationRealtime'
import { avatarColor, initials } from '@/composables/useHelpers'
import { toMediaUrl } from '@/utils/media'
import { exampleData, shortcutAction, shouldOpenExample, useInternalChatPopup } from '@/composables/useInternalChatPopup'
import { getMyGoogleChat, listRecentInternalConversations, searchDirectory, type DirectorySearchResult, type RecentInternalConversation } from '@/services/wootdashGoogleChat'

const CARD_W = 250
interface Geometry { left: number; top: number; width: number; height: number | null }
const GEOMETRY_KEY = 'wootdash.conversas-popup'
const MIN_WIDTH = 300
const MIN_HEIGHT = 260
const EDGE = 8

export default /*@__PURE__*/_defineComponent({
  __name: 'InternalChatPopup',
  setup(__props) {

// Ícone de balão na barra superior: últimas conversas do chat interno (com não lidas) e busca de agentes e do diretório
// da ISBET (G3). Selecionar abre o chat interno do WootDash (a gaveta de sempre). Tudo atualiza por SignalR.
const AVAILABILITY: Record<string, string> = { online: 'online', busy: 'ocupado', offline: 'offline' }
const AVAILABILITY_LABEL: Record<string, string> = { online: 'Online', busy: 'Ocupado', offline: 'Offline' }

// Modo exemplo (Ctrl+Shift+C sem o Google Workspace configurado): dados fictícios, só pra aprovar o visual.
const SAMPLE = exampleData()

const store = useStore()
const { can } = usePermission()
const token = computed<string>(() => store.getters.authUser?.wootdash_token ?? '')
const canUse = computed(() => can('agentChat.view'))
const { agents, unreadByAgent, totalUnread, panelOpen, loadingAgents, loadAgents, openThread } = useAgentChatCp()
const myId = computed<string>(() => store.getters.authUser?.wootdash_agent_id ?? '')
// Conversas ativas do Dashboard (abertas/pendentes) — alimentam o cartão de detalhes, como na aba Agentes.
const { conversations: liveConversations, scopeReady: liveReady } = useWootDashLiveData()
const { mode: railMode } = useChatRailMode()

const { shortcutRequests, state: popupState, exampleMode: example } = useInternalChatPopup()
const open = computed(() => popupState.value === 'open')
const query = ref('')
const q = computed(() => query.value.trim())
const recent = ref<RecentInternalConversation[]>([])
const loadingRecent = ref(false)
const directory = ref<DirectorySearchResult>({ enabled: true, people: [], problem: null })
const loadingDirectory = ref(false)
const btn = ref<HTMLElement | null>(null)
const pop = ref<HTMLElement | null>(null)
const searchEl = ref<HTMLInputElement | null>(null)
const popStyle = ref<Record<string, string>>({})

const exampleNote = ref<string | null>(null)
const allAgents = computed(() => (example.value ? SAMPLE.agents : agents.value))
const shownRecent = computed(() => (example.value ? SAMPLE.recent : recent.value))

const agentMatches = computed(() => {
  const text = q.value.toLowerCase()
  return allAgents.value.filter(a => a.name.toLowerCase().includes(text) || a.email.toLowerCase().includes(text)).slice(0, 20)
})
/** Do diretório, só quem não apareceu na lista de agentes (o agente já está acima). */
const directoryOthers = computed(() => {
  const shown = new Set(agentMatches.value.map(a => a.id.toLowerCase()))
  const text = q.value.toLowerCase()
  const people = example.value
    ? (q.value.length < 2 ? [] : SAMPLE.directory.filter(p => p.name.toLowerCase().includes(text) || p.email.toLowerCase().includes(text)))
    : directory.value.people
  return people.filter(p => !p.agentId || !shown.has(p.agentId.toLowerCase()))
})

const onlineCount = computed(() => allAgents.value.filter(a => a.availability === 'online').length)

// ── Cartão de detalhes ao passar o mouse: ao lado da janela (à esquerda; à direita se não couber) ──
const card = ref<{ agent: ChatAgentCp; stats: { open: number; pending: number } | null; style: Record<string, string> } | null>(null)

function statsOf(agentId: string) {
  if (example.value || !liveReady.value) return null
  let open = 0
  let pending = 0
  for (const c of liveConversations.value) {
    if (c.assignee?.id !== agentId) continue
    if (c.status === 'open') open++
    else if (c.status === 'pending') pending++
  }
  return { open, pending }
}

function showCard(agentId: string, e: MouseEvent) {
  const agent = allAgents.value.find(a => a.id.toLowerCase() === agentId.toLowerCase())
  const box = pop.value?.getBoundingClientRect()
  if (!agent || !box) { card.value = null; return }
  const row = (e.currentTarget as HTMLElement).getBoundingClientRect()
  const left = box.left - CARD_W - 10 >= 8 ? box.left - CARD_W - 10 : Math.min(box.right + 10, window.innerWidth - CARD_W - 8)
  const top = Math.max(8, Math.min(row.top - 8, window.innerHeight - 220))
  card.value = { agent, stats: statsOf(agent.id), style: { left: `${left}px`, top: `${top}px`, width: `${CARD_W}px` } }
}
function hideCard() { card.value = null }

function availabilityOf(agentId: string) {
  return allAgents.value.find(a => a.id.toLowerCase() === agentId.toLowerCase())?.availability ?? null
}

async function loadRecent() {
  loadingRecent.value = true
  recent.value = await listRecentInternalConversations(token.value)
  loadingRecent.value = false
}

let searchTimer: ReturnType<typeof setTimeout> | null = null
let searchSeq = 0
watch(q, text => {
  if (searchTimer) clearTimeout(searchTimer)
  exampleNote.value = null
  if (example.value) return
  if (text.length < 2) { directory.value = { ...directory.value, people: [], problem: null }; return }
  searchTimer = setTimeout(async () => {
    const mine = ++searchSeq
    loadingDirectory.value = true
    const result = await searchDirectory(token.value, text)
    if (mine !== searchSeq) return
    loadingDirectory.value = false
    directory.value = result
  }, 300)
})

// ── Posição e tamanho: o agente arrasta pelo cabeçalho e redimensiona pelo canto; fica guardado neste navegador ──
const geometry = ref<Geometry | null>(loadGeometry())
const moved = computed(() => geometry.value !== null)
const dragging = ref(false)

function loadGeometry(): Geometry | null {
  try {
    const saved = JSON.parse(localStorage.getItem(GEOMETRY_KEY) ?? 'null') as Geometry | null
    return saved && Number.isFinite(saved.left) && Number.isFinite(saved.top) && Number.isFinite(saved.width) ? saved : null
  } catch { return null }
}

function saveGeometry() {
  try {
    if (geometry.value) localStorage.setItem(GEOMETRY_KEY, JSON.stringify(geometry.value))
    else localStorage.removeItem(GEOMETRY_KEY)
  } catch { /* modo privado: vale só nesta visita */ }
}

/** Mantém o popup inteiro dentro da janela (a janela pode ter diminuído desde a última vez). */
function clamp(g: Geometry): Geometry {
  const width = Math.min(Math.max(g.width, MIN_WIDTH), window.innerWidth - EDGE * 2)
  const height = g.height === null ? null : Math.min(Math.max(g.height, MIN_HEIGHT), window.innerHeight - EDGE * 2)
  const left = Math.min(Math.max(g.left, EDGE), window.innerWidth - width - EDGE)
  const top = Math.min(Math.max(g.top, EDGE), window.innerHeight - (height ?? MIN_HEIGHT) - EDGE)
  return { left, top, width, height }
}

function place() {
  if (geometry.value) {
    const g = clamp(geometry.value)
    popStyle.value = { top: `${g.top}px`, left: `${g.left}px`, width: `${g.width}px`, ...(g.height === null ? { maxHeight: 'min(560px, 80vh)' } : { height: `${g.height}px`, maxHeight: 'none' }) }
    return
  }
  const width = Math.min(360, window.innerWidth - 16)
  // Sem o botão (agente sem o chat interno, no modo exemplo): canto superior direito.
  const r = btn.value?.getBoundingClientRect() ?? { bottom: 56, right: window.innerWidth - 16 }
  // Tamanho padrão: até 560px de altura; redimensionado, vale o que o agente escolheu.
  popStyle.value = { top: `${r.bottom + 8}px`, left: `${Math.max(8, Math.min(window.innerWidth - width - 8, r.right - width))}px`, width: `${width}px`, maxHeight: 'min(560px, 80vh)' }
}

function currentGeometry(): Geometry | null {
  const rect = pop.value?.getBoundingClientRect()
  return rect ? { left: rect.left, top: rect.top, width: rect.width, height: geometry.value?.height ?? null } : null
}

function startDrag(e: PointerEvent) {
  if (e.button !== 0 || (e.target as HTMLElement).closest('button')) return
  const start = currentGeometry()
  if (!start) return
  e.preventDefault()
  dragging.value = true
  const head = e.currentTarget as HTMLElement
  head.setPointerCapture(e.pointerId)
  const dx = e.clientX - start.left
  const dy = e.clientY - start.top
  const onMove = (ev: PointerEvent) => {
    geometry.value = clamp({ ...start, left: ev.clientX - dx, top: ev.clientY - dy })
    place()
  }
  const onUp = () => {
    dragging.value = false
    head.removeEventListener('pointermove', onMove)
    head.removeEventListener('pointerup', onUp)
    head.removeEventListener('pointercancel', onUp)
    saveGeometry()
  }
  head.addEventListener('pointermove', onMove)
  head.addEventListener('pointerup', onUp)
  head.addEventListener('pointercancel', onUp)
}

// Redimensionar: o canto do próprio popup (CSS resize). Guarda o tamanho quando a pessoa solta.
let resizeObserver: ResizeObserver | null = null
let resizeTimer: ReturnType<typeof setTimeout> | null = null
let lastSize = ''
function watchResize(el: HTMLElement | null) {
  resizeObserver?.disconnect()
  if (!el || typeof ResizeObserver === 'undefined') return
  lastSize = `${el.offsetWidth}x${el.offsetHeight}`
  resizeObserver = new ResizeObserver(() => {
    const size = `${el.offsetWidth}x${el.offsetHeight}`
    if (size === lastSize || dragging.value) return
    lastSize = size
    if (resizeTimer) clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      const rect = el.getBoundingClientRect()
      geometry.value = clamp({ left: rect.left, top: rect.top, width: rect.width, height: rect.height })
      saveGeometry()
    }, 200)
  })
  resizeObserver.observe(el)
}
watch(pop, el => watchResize(el))

function resetGeometry() {
  geometry.value = null
  saveGeometry()
  place()
  void nextTick(() => { lastSize = pop.value ? `${pop.value.offsetWidth}x${pop.value.offsetHeight}` : '' })
}

/** Abre do zero (o watch de popupState carrega tudo). */
function show(asExample: boolean) {
  example.value = asExample
  popupState.value = 'open'
}

/** Só o × fecha. */
function close() {
  popupState.value = 'closed'
  card.value = null
}

/** Vira o ícone de chat no canto inferior esquerdo (InternalChatBubble). */
function minimize() {
  popupState.value = 'minimized'
  card.value = null
}

// Abriu — do zero, do ícone minimizado ou pelo "voltar" do chat com um agente: mesmo lugar e tamanho, recentes e status
// dos agentes atualizados (uma leitura ao abrir, sem polling).
watch(popupState, (now, before) => {
  if (now !== 'open') return
  if (before === 'closed') { query.value = ''; exampleNote.value = null }
  place()
  if (!example.value) {
    void loadRecent()
    if (token.value && myId.value) void loadAgents(token.value, myId.value)
  }
  void nextTick(() => searchEl.value?.focus())
})

/** Botão da barra: fechado abre; minimizado volta; aberto minimiza (clicar fora não fecha mais). */
function toggle() {
  if (popupState.value === 'open') { minimize(); return }
  if (popupState.value === 'minimized') { popupState.value = 'open'; return }
  show(false)
}

/** Lê se a ponte e o diretório do Google Workspace estão prontos (Admin › Google Workspace). */
async function workspaceStatus() {
  const [me, dir] = await Promise.all([getMyGoogleChat(token.value), searchDirectory(token.value, '')])
  directory.value = dir
  return { bridge: me.bridgeEnabled, directory: dir.enabled }
}

// Ctrl+Shift+C: fechado abre (sem o Google Workspace configurado — ou sem o chat interno —, como exemplo); aberto
// minimiza; minimizado volta. Nunca fecha: só o × fecha.
watch(shortcutRequests, async () => {
  const action = shortcutAction(popupState.value)
  if (action === 'minimize') { minimize(); return }
  if (action === 'restore') { popupState.value = 'open'; return }
  const status = await workspaceStatus()
  show(shouldOpenExample(canUse.value, status.bridge, status.directory))
})

async function openChat(agentId: string) {
  if (example.value) {
    exampleNote.value = 'Exemplo: com o Google Workspace configurado, isso abre a conversa com a pessoa no chat interno.'
    return
  }
  // A conversa abre na gaveta; o popup fica minimizado no canto, à mão pra próxima.
  minimize()
  query.value = ''
  railMode.value = 'agent'
  panelOpen.value = true
  await openThread(token.value, agentId)
}

// Mensagem nova com o popup aberto: a lista de recentes muda na hora.
let recentTimer: ReturnType<typeof setTimeout> | null = null
const stopRealtime = onInternalMessage(() => {
  if (!open.value) return
  if (recentTimer) clearTimeout(recentTimer)
  recentTimer = setTimeout(() => { void loadRecent() }, 250)
})

onMounted(() => { window.addEventListener('resize', place) })
onBeforeUnmount(() => { window.removeEventListener('resize', place); stopRealtime(); resizeObserver?.disconnect() })

function when(iso: string) {
  const d = new Date(iso)
  const today = new Date()
  return d.toDateString() === today.toDateString()
    ? d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (canUse.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          ref_key: "btn",
          ref: btn,
          type: "button",
          class: "icp-btn",
          title: _unref(totalUnread) ? `Conversas (${_unref(totalUnread)} não lidas)` : 'Conversas',
          "aria-haspopup": "dialog",
          "aria-expanded": open.value,
          onClick: _withModifiers(toggle, ["stop"])
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
          ], -1)),
          (_unref(totalUnread))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(totalUnread) > 99 ? '99+' : _unref(totalUnread)), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "pop",
            ref: pop,
            class: "icp-pop",
            role: "dialog",
            "aria-label": "Conversas",
            style: _normalizeStyle(popStyle.value),
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icp-head", { dragging: dragging.value }]),
              title: "Arraste para mudar de lugar",
              onPointerdown: startDrag
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("b", null, "Conversas", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("span", {
                class: "icp-keys",
                title: "Atalho"
              }, "Ctrl+Shift+C", -1)),
              (moved.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "icp-reset",
                    title: "Voltar ao lugar e tamanho padrão",
                    "aria-label": "Voltar ao lugar padrão",
                    onClick: resetGeometry
                  }, "↺"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "icp-min",
                title: "Minimizar (fica um ícone no canto inferior esquerdo)",
                "aria-label": "Minimizar",
                onClick: minimize
              }, "–"),
              _createElementVNode("button", {
                type: "button",
                class: "icp-x",
                title: "Fechar",
                "aria-label": "Fechar",
                onClick: close
              }, "×")
            ], 34),
            (_unref(example))
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("b", null, "Exemplo.", -1),
                  _createTextVNode(" O Google Workspace ainda não está configurado (Admin › Google Workspace). Os nomes e mensagens abaixo são fictícios, só pra mostrar como o popup fica. ", -1)
                ]))]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              id: "icp-search",
              ref_key: "searchEl",
              ref: searchEl,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
              class: "icp-search",
              type: "search",
              placeholder: "Buscar pessoa por nome ou e-mail…",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, query.value]
            ]),
            (exampleNote.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(exampleNote.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (!q.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "icp-sec" }, "Últimas conversas", -1)),
                    (loadingRecent.value && !shownRecent.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Carregando…"))
                      : (!shownRecent.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Nenhuma conversa ainda. Escolha um agente abaixo."))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownRecent.value, (r) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: r.peerAgentId,
                        type: "button",
                        class: "icp-row",
                        onClick: ($event: any) => (openChat(r.peerAgentId)),
                        onMouseenter: ($event: any) => (showCard(r.peerAgentId, $event)),
                        onMouseleave: hideCard
                      }, [
                        _createElementVNode("span", {
                          class: "icp-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(r.peerName) })
                        }, [
                          (r.peerAvatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(toMediaUrl)(r.peerAvatarUrl)!,
                                alt: ""
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(initials)(r.peerName)), 1)
                              ], 64)),
                          (availabilityOf(r.peerAgentId))
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 2,
                                class: _normalizeClass(["icp-dot", `is-${availabilityOf(r.peerAgentId)}`])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ], 4),
                        _createElementVNode("span", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _createElementVNode("b", null, _toDisplayString(r.peerName), 1),
                            _createElementVNode("small", null, _toDisplayString(when(r.lastAt)), 1)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["icp-prev", { unread: r.unread }])
                          }, _toDisplayString(r.fromMe ? 'Você: ' : '') + _toDisplayString(r.lastBody), 3)
                        ]),
                        (r.unread)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(r.unread), 1))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_9))
                    }), 128)),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "Agentes", -1)),
                      _createElementVNode("span", _hoisted_15, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icp-mini-dot" }, null, -1)),
                        _createTextVNode(_toDisplayString(onlineCount.value) + " online · " + _toDisplayString(allAgents.value.length) + " no total", 1)
                      ])
                    ]),
                    (!allAgents.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(loadingAgents) ? 'Carregando…' : 'Nenhum outro agente.'), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAgents.value, (a) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: a.id,
                        type: "button",
                        class: _normalizeClass(["icp-row", { 'is-offline': a.availability === 'offline' }]),
                        onClick: ($event: any) => (openChat(a.id)),
                        onMouseenter: ($event: any) => (showCard(a.id, $event)),
                        onMouseleave: hideCard
                      }, [
                        _createElementVNode("span", {
                          class: "icp-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(a.name) })
                        }, [
                          (a.avatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(toMediaUrl)(a.avatarUrl)!,
                                alt: ""
                              }, null, 8, _hoisted_18))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(initials)(a.name)), 1)
                              ], 64)),
                          _createElementVNode("i", {
                            class: _normalizeClass(["icp-dot", `is-${a.availability}`])
                          }, null, 2)
                        ], 4),
                        _createElementVNode("span", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, [
                            _createElementVNode("b", null, _toDisplayString(a.name), 1),
                            _createElementVNode("small", {
                              class: _normalizeClass(`icp-st-${a.availability}`)
                            }, _toDisplayString(AVAILABILITY[a.availability]), 3)
                          ]),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(a.role || a.email), 1)
                        ]),
                        (!_unref(example) && _unref(unreadByAgent)[a.id])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(unreadByAgent)[a.id]), 1))
                          : _createCommentVNode("", true)
                      ], 42, _hoisted_17))
                    }), 128))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "icp-sec" }, "Agentes do WootDash", -1)),
                    (!agentMatches.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Nenhum agente com \"" + _toDisplayString(query.value.trim()) + "\".", 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agentMatches.value, (a) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: a.id,
                        type: "button",
                        class: "icp-row",
                        onClick: ($event: any) => (openChat(a.id)),
                        onMouseenter: ($event: any) => (showCard(a.id, $event)),
                        onMouseleave: hideCard
                      }, [
                        _createElementVNode("span", {
                          class: "icp-av",
                          style: _normalizeStyle({ background: _unref(avatarColor)(a.name) })
                        }, [
                          (a.avatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(toMediaUrl)(a.avatarUrl)!,
                                alt: ""
                              }, null, 8, _hoisted_25))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(initials)(a.name)), 1)
                              ], 64)),
                          _createElementVNode("i", {
                            class: _normalizeClass(["icp-dot", `is-${a.availability}`])
                          }, null, 2)
                        ], 4),
                        _createElementVNode("span", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, [
                            _createElementVNode("b", null, _toDisplayString(a.name), 1),
                            _createElementVNode("small", null, _toDisplayString(AVAILABILITY[a.availability]), 1)
                          ]),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(a.email), 1)
                        ]),
                        (!_unref(example) && _unref(unreadByAgent)[a.id])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(unreadByAgent)[a.id]), 1))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_24))
                    }), 128)),
                    (directory.value.enabled || _unref(example))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "icp-sec" }, "Diretório da ISBET", -1)),
                          (q.value.length < 2)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Digite pelo menos 2 letras."))
                            : (loadingDirectory.value && !_unref(example))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Procurando no diretório…"))
                              : (directory.value.problem && !_unref(example))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(directory.value.problem), 1))
                                : (!directoryOthers.value.length)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Ninguém mais no diretório com \"" + _toDisplayString(query.value.trim()) + "\".", 1))
                                  : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directoryOthers.value, (p) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: p.email,
                              class: "icp-row icp-row--static",
                              title: p.agentId ? '' : 'Esta pessoa não usa o WootDash'
                            }, [
                              _createElementVNode("span", {
                                class: "icp-av",
                                style: _normalizeStyle({ background: _unref(avatarColor)(p.name) })
                              }, [
                                (p.photoUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: p.photoUrl,
                                      alt: "",
                                      referrerpolicy: "no-referrer"
                                    }, null, 8, _hoisted_35))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_unref(initials)(p.name)), 1)
                                    ], 64))
                              ], 4),
                              _createElementVNode("span", _hoisted_36, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createElementVNode("b", null, _toDisplayString(p.name), 1)
                                ]),
                                _createElementVNode("span", _hoisted_38, _toDisplayString(p.email), 1)
                              ]),
                              (p.agentId)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "icp-open",
                                    onClick: ($event: any) => (openChat(p.agentId))
                                  }, "Conversar", 8, _hoisted_39))
                                : (_openBlock(), _createElementBlock("span", _hoisted_40, "não está no WootDash"))
                            ], 8, _hoisted_34))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
            ])
          ], 4))
        : _createCommentVNode("", true),
      (open.value && card.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "icp-card",
            style: _normalizeStyle(card.value.style),
            role: "tooltip"
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("span", {
                class: "icp-card-av",
                style: _normalizeStyle({ background: _unref(avatarColor)(card.value.agent.name) })
              }, [
                (card.value.agent.avatarUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(toMediaUrl)(card.value.agent.avatarUrl)!,
                      alt: ""
                    }, null, 8, _hoisted_42))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_unref(initials)(card.value.agent.name)), 1)
                    ], 64)),
                _createElementVNode("i", {
                  class: _normalizeClass(["icp-dot", `is-${card.value.agent.availability}`])
                }, null, 2)
              ], 4),
              _createElementVNode("span", _hoisted_43, [
                _createElementVNode("b", null, _toDisplayString(card.value.agent.name), 1),
                _createElementVNode("small", null, _toDisplayString(card.value.agent.role || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              (card.value.agent.email)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                    _cache[11] || (_cache[11] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
                      _createElementVNode("polyline", { points: "22,6 12,13 2,6" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_46, _toDisplayString(card.value.agent.email), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_47, [
                _cache[12] || (_cache[12] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "10"
                  })
                ], -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["icp-card-badge", `is-${card.value.agent.availability}`])
                }, _toDisplayString(AVAILABILITY_LABEL[card.value.agent.availability]), 3)
              ]),
              (card.value.stats)
                ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "3",
                        width: "18",
                        height: "18",
                        rx: "2"
                      }),
                      _createElementVNode("line", {
                        x1: "9",
                        y1: "9",
                        x2: "9",
                        y2: "15"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(card.value.stats.open) + " aberta(s) · " + _toDisplayString(card.value.stats.pending) + " pendente(s) ", 1)
                  ]))
                : _createCommentVNode("", true),
              (card.value.stats?.open)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                      _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                    ], -1),
                    _createTextVNode(" em atendimento ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (!_unref(example) && _unref(unreadByAgent)[card.value.agent.id])
                ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(unreadByAgent)[card.value.agent.id]) + " mensagem(ns) não lida(s)", 1))
                : _createCommentVNode("", true)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})